import { Controller } from "stimulus"
import Cropper from 'cropperjs';
import 'cropperjs/dist/cropper.css';

export default class extends Controller {
  static targets = ['image', 'filename', 'modal', 'modalImage', "modalPreview"]
  static values = {
    defaultImageUrl: String
  }

  cropper = null;

  connect() {
    this.cropper;
    this.preview = document.querySelector('.website-previewer iframe').contentWindow;
    this.deletedImageIds = document.getElementById("deleted-image-ids");
  }


  openModal(e) {
    this.modalTarget.style.display = "flex";
      this.cropper = new Cropper(this.modalImageTarget, {
        aspectRatio: 16 / 9,
        preview: this.modalPreviewTarget,
        checkCrossOrigin: false,
        checkOrientation: false,
      });
  }

  closeModal(e){
    this.modalTarget.style.display = "none";
    this.cropper.destroy();
  }

  setMove(e) {
    this.cropper.setDragMode("move");
  }
  setCrop(e) {
    this.cropper.setDragMode("crop");
  }
  rotateLeft(e) {
    this.cropper.rotate(-45);
  }
  rotateRight(e) {
    this.cropper.rotate(45);
  }

  delete(e){
    if(this.imageTarget.id != ""){
      this.deletedImageIds.value = this.deletedImageIds.value + this.imageTarget.id  + ",";
    }
    this.element.remove();
    this.updatePreview();
    document.getElementById("upload-label").classList.remove("hidden");
  }

  saveModal(e){
    e.preventDefault();
    let dataURL = this.cropper.getCroppedCanvas({fillColor: '#ffffff'}).toDataURL();
    this.imageTarget.src = dataURL;
    this.modalTarget.style.display = "none";
    if(this.imageTarget.id != "" && this.imageTarget.id != "pexel"){
      this.deletedImageIds.value = this.deletedImageIds.value + this.imageTarget.id  + ",";
      this.imageTarget.removeAttribute("id");
    }
    this.updatePreview();
    this.cropper.destroy();
  }

   dataURLtoFile(dataURL) {
    var byteString = atob(dataURL.split(',')[1]);
    var mimeString = dataURL.split(',')[0].split(':')[1].split(';')[0];
    
    var ab = new ArrayBuffer(byteString.length);
    var ia = new Uint8Array(ab);
    for (var i = 0; i < byteString.length; i++) {
        ia[i] = byteString.charCodeAt(i);
    }

    let file = new File([new Blob([ab], {type: mimeString})], this.filenameTarget.innerText,{type:"image/jpeg", lastModified:new Date().getTime()}, 'utf-8');
    return file
  }

  updatePreview() {
    let images = [document.getElementById("uploaded-images").querySelectorAll(".image")][0];
    let imagesURLs = [];
    for(const img of images){
      imagesURLs.push(img.src);
    }
    this.preview.postMessage({action: 'website_preview:update_slider', target: '[data-preview=gallery]', value: imagesURLs})
  }
}